import React from "react";
import { createUseStyles } from "react-jss";
import clsx from "clsx";

const useStyles = createUseStyles(theme => ({
  flash: {
    width: 300,
    "max-width": "100%",
    padding: theme.spacing2,
    "text-align": "center",
    "border-radius": theme.borderRadius,
    "box-sizing": "border-box",
    "margin-top": 15,
  },
  error: {
    backgroundColor: `${theme.colorError}99`,
  },
}));

const Flash = ({ message, type }) => {
  const classes = useStyles();
  return <div className={clsx(classes.flash, classes[type])}>{message}</div>;
};

export default Flash;
